/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/8
 * @updateTime 2021/11/8
 * @decription 公共业务组件=》预览文件组件
 */
// 上传文件组件
import acUploadFile from '@/components/app/upload-file/index.vue';
export default {
    name: 'ac-preview-file',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        acUploadFile
    },
    // 参数
    props: {
        // 标题
        title: {
            type: String
        },
        // 文件列表
        data: {
            type: Array
        }
    },
    // 数据
    data() {
        return {
            scope: {
                prefixCls: 'fd-ac-preview-file'
            }
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 创建完成
    },
    // 组件激活
    activated() {
        // 激活完成
    },
    // 组件初始化完成
    mounted() {
        // 初始化完成
    },
    // 组件失去激活
    deactivated() {
        // 失去激活
    },
    // 销毁之前
    beforeDestroy() {
        // 销毁之前
    },
    // 方法
    methods: {}
};
